import { SystemBaseApi } from "./SystemBaseApi";
import { Methods } from '@newview/infrastructure';

/**
 * Api
 */
export class SubsystemmodulerelationApi extends SystemBaseApi {
    public get ControllerName(): any {
        return 'subsystemmodulerelation'
    }


    /**
     * 查询数据类别列表
     * @returns 
     */
    public getModuleListBySubId(subSystemId){
        return this.send({subSystemId:subSystemId},"getModuleListBySubId",Methods.GET)
    }

    /**
     * 子系统id删除
     * @param id 
     * @returns 
     */
    public deleteBySubSystemId(id){
      return this.send({},"deleteBySubSystemId?subSystemId="+id,Methods.POST)
    }
    /**
     * 子系统菜单关系表设置
     * @param params 
     */
    public saveRelation(params){
      return this.send(params,"saveRelation",Methods.POST);
    }
      /**
     * 根据子系统DI 获取需要流程 资源
     * @returns 
     */
       public getModuleListBySubIdAndIsAudit(subSystemId,isAudit){
        return this.send({subSystemId:subSystemId,isAudit:isAudit},"getModuleListBySubIdAndIsAudit",Methods.GET)
    }


    



}